import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Injectable } from '@angular/core';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';

import { ToastrService } from 'ngx-toastr';

import { environment } from '../../../../../environments/environment';
import { ModalsAddCardSuccessComponent } from '../../../../shared/components/modals/modals-add-cart-success/modals-add-cart-success.component';
import { map, catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShoppingCartService {

  public totalItems: number = 0;
  public items: any;
  public totalPayment: number = 0;

  constructor(
    private bsModalService: BsModalService,
    private toastr: ToastrService,
    private http: HttpClient
  ) {}

  public clear() {
    this.items = [];
  }

  public addItem(idCliente: number, idProduto: number) {     
    this.toastr.info('Aguarde... adicionando ao carrinho', null, {
      timeOut: 3000,
      positionClass: 'toast-bottom-center',
      progressAnimation: 'decreasing',
      closeButton: true
    });

    return this.http.post<any[]>(`${environment.api}/carts`, { idCliente, idProduto } ).pipe(      
      map((result: any) => {
        this.totalItems += 1; 
        return result.message
      }),
      catchError(this.handleError)
    );  
  }


  /**
   * description: busca todos as compras que estão no carrinho
   */
  public getAllCartByCustomerId() {                                                                   
    return this.http.get<any[]>(`${environment.api}/carts` ).pipe(      
      map((result: any) =>  {
        this.items = result.data;
        this.totalItems = result.data.items.length;
        return result.data;
      }),
      catchError(error => error)
    );
  }
  
  public removeItem(item: any) {   
    this.toastr.info('Removendo item do carrinho', null, {
      timeOut: 3000,
      positionClass: 'toast-bottom-center',
      progressAnimation: 'decreasing',
      closeButton: true
    });
    
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: { idItem: item.idItem, idPedido: item.idPedido, idProduto: item.idProduto }
    }    

    return this.http.delete<any>(`${environment.api}/carts`, options ).pipe(      
      map(() =>  {
        this.totalItems -= 1;
        this.items.items.splice(this.items.items.indexOf(item), 1); 
             
        this.toastr.success('Removido com sucesso', null, {
          timeOut: 3000,
          positionClass: 'toast-bottom-center',
          progressAnimation: 'decreasing',
          closeButton: true
        });

        return true;
      }),
      catchError(this.handleError)
    );
  }

  public total(): number {
    return 0;
  }


  // METHODS PRIVATE  
  private handleError(error: any): Observable<any> {
    //console.log("ERRO NA REQUISIÇÃO =>", error);
    return throwError(error);
  }
}